import AutocompleteWrapper from '@/components/AutocompleteWrapper/AutocompleteWrapper'
import type { TypeAheadConfigEndpoint } from '@/components/TypeAhead/types'
import useSeti from '@/hooks/useSeti'
import logSearchFormAnalytics from '@/shared-utils/log-search-form-analytics'
import pclnExperimentation from '@pcln/experimentation'
import { PackageSearchForm } from '@pcln/horizon-search-form'
import type { PackagesFormStateType } from '../types'
import usePackagesFormInitialValues from './usePackagesFormInitialValues'

const DEFAULT_PICKUP_TIME = '12:00'
const DEFAULT_DROPOFF_TIME = '12:00'

export default function HorizonPackagesForm({
  onSubmit,
  pageName,
}: Readonly<{
  onSubmit: (pageName: 'homepage' | 'landing', data: PackagesFormStateType) => void
  pageName: 'homepage' | 'landing'
}>) {
  const { initialValues, isMobile, cguid, localeCode } = usePackagesFormInitialValues()
  const flyTypeaheadSeti = useSeti({ experimentCode: 'PKG_AC_FLY_TYPEAHEAD', shouldFireImpression: false })
  return (
    <PackageSearchForm
      initialValues={initialValues}
      isMobile={isMobile}
      autoAdvance={!isMobile}
      localeCode={localeCode}
      pageName={pageName}
      defaultPickupTime={DEFAULT_PICKUP_TIME}
      defaultDropoffTime={DEFAULT_DROPOFF_TIME}
      useFlightTypeaheadForFlyDrive={flyTypeaheadSeti === 'VARIANT'}
      onSubmit={(data) => {
        if (data.tripType === 'FLY:DRIVE') {
          pclnExperimentation.fireImpression('PKG_AC_FLY_TYPEAHEAD')
        }
        onSubmit(pageName, data as PackagesFormStateType)
        logSearchFormAnalytics({ cguid, pageName, productType: 'vacations', isMobile })
      }}
      renderAutocomplete={(props) => (
        <AutocompleteWrapper
          ref={props.inputRef}
          searchKey={props.searchKey}
          label={props.label}
          typeAheadEndpoint={props.typeAheadEndpoint as TypeAheadConfigEndpoint}
          errorMessage={props.errorMessage}
          initialSelectedItem={props.initialSelectedItem}
          onItemSelect={(item) => props.onItemSelect(item)}
        />
      )}
    />
  )
}
